/* ============
 * Getters for the organisations module
 * ============
 *
 * The getters that are available on the
 * organisations module.
 */
import {
  clone
} from '@/utils/object';
const getOrganisations = state => clone(state.organisation);

export default {
  getOrganisations
};
